import { inject, Injectable } from '@angular/core';
import { Router, RouterStateSnapshot, UrlTree } from '@angular/router';

import { environment } from 'src/environments/environment';
import { Logger } from '../../services/logger/logger.service';

const LOGGER = new Logger('LegacyClientUrlGuard');

/**
 * Rattrape les URL de l'ancienne forme, sans dossier (#173, décisions 5 et 7).
 *
 * On ne devine pas le dossier à la place de l'utilisateur : l'URL renvoie vers le
 * sélecteur, en conservant l'écran visé dans `next`. Il est restitué une fois le
 * dossier choisi — ou immédiatement si l'utilisateur n'a qu'un seul dossier.
 *
 * La redirection est **définitive** : elle couvre les favoris et les liens déjà
 * partagés. Elle rend en revanche un lien non migré invisible ; d'où la trace
 * console en développement.
 */
@Injectable({
    providedIn: 'root'
})
export class LegacyClientUrlGuard {
    private _router = inject(Router);

    canActivate(_: unknown, state: RouterStateSnapshot): UrlTree {
        // `/home/dashboard` devient `/c/:clientId/dashboard` : on retire le préfixe
        const next = state.url.replace(/^\/home(?=\/|$)/, '');

        if (!environment.production) {
            LOGGER.warn(`URL sans dossier : « ${state.url} ». Lien à migrer vers /c/:clientId (#173).`);
        }

        return this._router.createUrlTree(['/home'], { queryParams: { next } });
    }
}
